import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-questionnaire-completed',
  templateUrl: './questionnaire-completed.component.html',
  styleUrls: ['./questionnaire-completed.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class QuestionnaireCompletedComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
